import { createContext, useContext, useState, ReactNode } from 'react';
import { AutomationContextValue, AutomationModalPane } from '../types';
import { AutomationModalPaneOptions } from '../enums';
import { JobViewQuestion } from 'types';

interface AutomationProviderProps {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  roleId: number;
  questions: JobViewQuestion[];
}

export const AutomationContext = createContext<AutomationContextValue | null>(null);

export const AutomationProvider = ({
  children,
  onClose,
  open,
  roleId,
  questions,
}: AutomationProviderProps) => {
  const [currentPane, setCurrentPane] = useState<AutomationModalPane>(
    AutomationModalPaneOptions.CREATE
  );
  const [selectedQuestionId, setSelectedQuestionId] = useState<number | null>(null);

  const value: AutomationContextValue = {
    open,
    onClose,
    onChangeModalPane: setCurrentPane,
    currentPane,
    roleId,
    questions,
    selectedQuestionId,
    setSelectedQuestionId,
  };

  return <AutomationContext.Provider value={value}>{children}</AutomationContext.Provider>;
};

export const useAutomation = (): AutomationContextValue => {
  const context = useContext(AutomationContext);
  if (!context) {
    throw new Error('useAutomation must be used within an AutomationProvider');
  }
  return context;
};
